import { PHONE, locationSchema } from "../structured-data-core";

export function getJacksonvilleStructuredData() {
  const url = "https://restorehair.com/locations/florida/jacksonville/";
  const description =
    "Find out about your hair transplant options in Jacksonville with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Jacksonville", "4651 Salisbury Rd, Suite 400", "Jacksonville", "FL", PHONE, url, description),
  ];
}
